import {DOCUMENT, inject, Injectable, OnDestroy, Signal, signal, WritableSignal} from '@angular/core';
import {STATIC_CONFIGS} from '../../../configs/static.config';

@Injectable()
export class TabletDocumentPreviewResizeObserverService implements OnDestroy {
    private readonly hideHistoryButtonSignal: WritableSignal<boolean> = signal(true);
    private readonly window = inject(DOCUMENT).defaultView || window;
    private readonly resizeObserver: ResizeObserver;

    public constructor() {
        // Aktuell nutzen wir Media-Queries, um die Dokumentenvorschau auch im zweispaltigen Design auf kleineren Geräten im Portrait-Modus über die gesamte Seite anzuzeigen. Wir blenden die
        // andere Seite einfach über 'display: none' aus. In dem Fall muss der History-Button in der Vorschau angezeigt werden, damit der Benutzer die Vorschau wieder verlassen kann.
        // Dafür brauchen wir diesen ResizeObserver, damit wir dynamisch darauf reagieren können, ob der Button angezeigt werden sollte oder nicht.
        // Im Rahmen des Neubaus der Vorschau wird das Verhalten hoffentlich soweit überarbeitet, dass dieser Service nicht mehr nötig ist und das ganze besser gelöst werden kann.
        this.resizeObserver = new ResizeObserver((resizeObserverEntries) => {
            resizeObserverEntries.forEach(resizeObserverEntry => {
                const width = resizeObserverEntry.contentBoxSize[0].inlineSize;
                const height = resizeObserverEntry.contentBoxSize[0].blockSize;
                // Der Zurück-Button muss immer dann angezeigt werden, wenn die Vorschau ganzseitig (einspaltig) dargestellt wird und die Liste daneben ausgeblendet ist.
                // Das ist sowohl im kleinen Viewport (Smartphone) als auch im zweispaltigen Tablet-Design im Portrait-Modus der Fall.
                const isSmallViewport = width < STATIC_CONFIGS.ui.breakpoints.twoColumnMinWidth ||
                    (height < STATIC_CONFIGS.ui.breakpoints.twoColumnMinHeight && width > height);
                const isTabletPortraitPreview = width >= STATIC_CONFIGS.ui.breakpoints.twoColumnMinWidth &&
                    width <= STATIC_CONFIGS.ui.breakpoints.portraitModeDocumentPreviewOneColumnMaxWidth &&
                    width <= height;
                this.hideHistoryButtonSignal.set(!(isSmallViewport || isTabletPortraitPreview));
            });
        });

        this.resizeObserver.observe(this.window.document.body);
    }

    public ngOnDestroy(): void {
        this.resizeObserver.disconnect();
    }

    public getHideHistoryButtonSignal(): Signal<boolean> {
        return this.hideHistoryButtonSignal.asReadonly();
    }
}
